export default [
    {
        path: "service-orders",
        name: "operations-service-orders",
        redirect: { name: "operations-service-orders-list" },
        component: () => import("@/views/operations/views/service-orders/ServiceOrders.vue"),
        meta: {
            section: 32,
            breadcrumb: [
                {
                    text: "Service Orders",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Services",
                    name: "operations-service-orders-list",
                },
            ],
        },
        children: [
            {
                path: "list",
                name: "operations-service-orders-list",
                component: () =>
                    import("@/views/operations/views/service-orders/components/ServiceOrdersGrid.vue"),
                meta: {
                    section: 32,
                    pageTitle: "Service Orders",
                    breadcrumb: [
                        {
                            text: "Services",
                        },
                    ],
                },
            },
        ]
    }
];